<h1 mat-dialog-title *ngIf="data.error.message">{{ data.caption }}
  <span *ngIf="!(data.error.status == 0)">
    - <span style="color: red;">{{ data.error.status }}</span>
  </span>
</h1>
<h1 mat-dialog-title *ngIf="!(data.error.message)">{{ data.caption }}
  <span *ngIf="!(data.error.status == 0)">
    - <span style="color: red;">{{ data.error.status }}</span>
  </span>
</h1>
<hr>
<mat-dialog-content class="mat-typography" style="text-align: center;">
  <h3 class="mat-headline">
    <i>{{ data.caption }}</i>
  </h3>
  <!--<ul>
    <li class="mat-subheading-1" *ngFor="let detail of data.error.error.details">
      {{ detail }}
    </li>
  </ul>
   <p>{{ data.error | json }}</p> -->
</mat-dialog-content>
<hr class="mb-2">
<mat-dialog-actions align="center">
  <button mat-stroked-button mat-dialog-close>Chiudi</button>
</mat-dialog-actions>